<template>
    <main>
        <div class="d-flex p-4 alert alert-danger rounded-lg shadow-sm border-left-lg border-left-danger mb-3" v-if="antecedentes.length">
            <i class="fa fa-exclamation-triangle fa-2x mr-4 text-danger animate__animated animate__heartBeat animate__infinite mt-1"></i> 
            <div class="w-100">
                <div v-for="(grupo, idxGrupo) in antecedentes" :key="grupo.grupo_id" :class="{'mb-0': idxGrupo === antecedentes.length - 1, 'mb-3': idxGrupo !== antecedentes.length - 1}">
                    <h5 class="font-weight-bold text-danger mb-2">{{ grupo.grupo_nombre }}</h5>
                    <ul class="mb-0 pl-4">
                        <li class="text-uppercase small mb-1" v-for="(item,index) in grupo.antecedentes" :key="index">
                           <span class="font-weight-bold text-dark">{{ item.nombre }}:</span> <span class="text-secondary">{{ item.valor }}</span>
                        </li>
                    </ul>
               </div>
            </div>
        </div>
    </main>
</template>
<script>
import antecedenteUsuarioService from "../../../../services/antecedenteUsuarioService";
import 'animate.css';
export default {
    props:['usuario'],
    data(){
        return{
            antecedentes:{}
        }
    },
    methods:{
        async getAntecedentes(){
            const response = await antecedenteUsuarioService.getAntecedenteUsuario({
                idusuario:this.usuario.id
            });
            this.antecedentes = response.data;
        }
    },
    async created(){
        await this.getAntecedentes();
    },
    watch:{
        'usuario':function(){
            this.getAntecedentes();
        }
    }
    
}
</script>